import React from "react";
import styled from "styled-components";
import { getWhiteLableObject } from "../../../config/whitelable";

const LogoImageContainer = styled.img<{ $width?: string; $height?: string }>`
  width: ${(props) => props.$width || "auto"};
  height: ${(props) => props.$height || "auto"};
`;

const LogoImage: React.FC = () => {
  return <LogoImageContainer
    src={`/logos/${getWhiteLableObject().logo.filename}`}
    alt={`${getWhiteLableObject().name}`}
    $width={`${getWhiteLableObject().loginImage.width}`}
    $height={`${getWhiteLableObject().loginImage.height}`}
  />;
};

export default LogoImage;
